const fetcher = (auth) => {
    return async (url) => {
        const storedDeviceId = localStorage.getItem("device-id");

        let method = "GET";
        const response = await fetch(url, {
            method,
            headers: {
                "x-cc-device-id": storedDeviceId,
                authorization: auth.accessToken,
                "ngrok-skip-browser-warning": "true",
            },
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        return data?.data ?? [];
    };
};

export default fetcher;
